export default __webpack_public_path__ + "static/media/Img_ApplyNow_02.32b72503.jpg";